import apiClient from "../helpers/apiClient";
const API = `/api/v2/transactions`
const api = apiClient();

export const getPointsData = (type) => api.get(`${API}/points/${type}`);
export const getPointsDataByHostId = (id) => api.get(`${API}/points-by-host/${id}`);
export const getPointsDataByAlmacenId = (id) => getPointsDataByHostId(id);
export const getRankingHostResto = () => api.get(`${API}/host/ranking/resto`);
export const getRankingHostLocal = () => api.get(`${API}/host/ranking/local`);
export const getRankingHostGlobal = () => api.get(`${API}/host/ranking/global`);
export const getPositionHost = () => api.get(`${API}/host/position`);
export const postLike = (workerId, clientId) => api.post(`${API}/like`, { workerId, clientId });
export const redeemPoints = (body) => api.post(`${API}/redeem`, body);
